import React from "react";
import { Tooltip } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { translate } from "../../translate/translate";

interface WarningTooltipProps {
  messageKey: string;
  additionalText?: string;
  /** Cor do ícone (default = var(--blue-gray-600)) */
  color?: string;
  /** Ícone alternativo (default = <ErrorIcon/>) */
  IconComponent?: React.ElementType;
}

const WarningTooltip: React.FC<WarningTooltipProps> = ({
  messageKey,
  additionalText = "",
  color = "var(--blue-gray-600)",
  IconComponent = ErrorIcon,
}) => {
  return (
    <Tooltip
      title={<p style={{ fontSize: "12px" }}>{translate.t(messageKey) + additionalText}</p>}
      placement="top"
      arrow
    >
      <IconComponent
        style={{ marginLeft: 8, cursor: "pointer" }}
        htmlColor={color}
        fontSize="small"
      />
    </Tooltip>
  );
};

export default WarningTooltip;
